import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import partial from "lodash/partial";
import { notificationAction } from "notifications/ducks";
import Wrapper from "notifications/components/wrapper";

export function mapStateToProps({ user }) {
  const userId = user.logged_in ? user.profile_data.id : null;

  return { userId };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      read: partial(notificationAction, "read"),
      clear: partial(notificationAction, "clear"),
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper);
